import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import CustomTable from "../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import * as snackbarActions from "../../actions/snackbarActions";
import { config } from "../../Helpers/env";
import { LoadingGif } from "../Utils/Loader";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import PageTitle from "../Utils/smsTitle";
import { SubHeader } from "../../Containers/SubHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { BackButton } from "../Utils/Buttons/DataExportationButton";
import { Container } from "../Utils/styledComponents";

const headData = [
  { id: "sl", label: "SL" },
  { id: "provider_name", label: "Provider Name" },
  { id: "provider_type", label: "Type" },
  { id: "currency", label: "Currency" },
  { id: "0_to_30", label: "0-30 Days" },
  { id: "31_to_60", label: "31-60 Days" },
  { id: "61_to_90", label: "61-90 Days" },
  { id: "over_90", label: "Over 90 Days" },
  { id: "total", label: "Total" }
];

const DebtorsAgeingReport = ({ actions, snackbars }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ data: [], total_count: 0, total_pages: 0 });
  const [activePage, setActivePage] = useState(1);
  const perPage = 10;

  const { data: rows = [], total_count = 0 } = data;

  // Simple client-side totals from the current page (or adjust if backend returns summary)
  const summary = rows.reduce(
    (acc, row) => {
      const parse = (val) => {
        if (typeof val === "number") return val;
        if (!val || val === 0) return 0;
        // handles values like "SSP 1,234.00" or plain numbers
        const num = parseFloat(String(val).replace(/[^0-9.-]+/g, ""));
        return isNaN(num) ? 0 : num;
      };
      acc.d0_30 += parse(row["0_to_30"]);
      acc.d31_60 += parse(row["31_to_60"]);
      acc.d61_90 += parse(row["61_to_90"]);
      acc.over90 += parse(row.over_90);
      acc.total += parse(row.total);
      return acc;
    },
    { d0_30: 0, d31_60: 0, d61_90: 0, over90: 0, total: 0 }
  );

  const fetchReport = async (page = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(`${config.smsUrl}/caccounting/debtors_ageing`, {
        params: {
          search: searchTerm || undefined,
          page,
          per_page: perPage
        }
      });
      setData(res.data || { data: [], total_count: 0, total_pages: 0 });
    } catch (err) {
      actions.snackbarActions.errorSnackbar?.("Failed to load debtors ageing report");
      setData({ data: [], total_count: 0, total_pages: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setActivePage(1);
  }, [searchTerm]);

  useEffect(() => {
    fetchReport(activePage);
  }, [searchTerm, activePage]);

  const exportExcel = () => {
    const url = `${config.smsUrl}/caccounting/debtors_ageing_export?download=1&search=${encodeURIComponent(searchTerm)}`;
    window.open(url);
  };

  const exportPdf = () => {
    const url = `${config.smsUrl}/caccounting/debtors_ageing_export?download=2&search=${encodeURIComponent(searchTerm)}`;
    window.open(url);
  };

  const formatMoney = (val) =>
    Number(val || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

  return (
    <Container className="mt-1">
      <PageTitle title="Debtors Ageing Report" />
      <SubHeader title="Accounting" subTitle="Debtors Ageing Summary">
        <FontAwesomeIcon icon={faUsers} />
      </SubHeader>

      <MainSnackbar
        open={snackbars.openBar}
        variant={snackbars.type}
        message={snackbars.message}
        handleCloseBar={actions.snackbarActions.hideSnackbar}
      />

      <div style={{ margin: "10px" }}>
        <BackButton to="/reports/generalreports" text="Accounting" />
      </div>

     {/* Filter Bar */}
{/* Filter Bar */}
{/* Filter Bar */}
<div className="card border-0 shadow-sm mb-3">
  <div className="card-body py-2 px-4 row g-2 align-items-center">
    <div className="col-auto">
      <input
        type="text"
        placeholder="Search provider name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="form-control form-control-sm"
        style={{ minWidth: "220px" }}
      />
    </div>
    <div className="col-auto">
      <button
        onClick={() => fetchReport(activePage)}
        disabled={loading}
        className="btn btn-sm text-white"
        style={{ backgroundColor: "#389081", borderColor: "#389081" }}
      >
        Refresh
      </button>
      <button
        onClick={exportExcel}
        className="btn btn-sm text-white ms-1"
        style={{ backgroundColor: "#389081", borderColor: "#389081" }}
      >
        <FontAwesomeIcon icon={faFileExcel} /> Excel
      </button>
      <button
        onClick={exportPdf}
        className="btn btn-sm text-white ms-1"
        style={{ backgroundColor: "#389081", borderColor: "#389081" }}
      >
        <FontAwesomeIcon icon={faFilePdf} /> PDF
      </button>
    </div>
  </div>
</div>
      {/* SUMMARY CARDS – system colors */}
      <div className="row g-3 mb-4">
        <div className="col-6 col-md-3">
          <div
            className="card border-0 shadow-sm text-white"
            style={{ background: "linear-gradient(135deg, #389081, #027a5f)" }}
          >
            <div className="card-body text-center py-4">
              <h6 className="mb-2 opacity-75">0-30 Days</h6>
              <h3 className="mb-0 fw-bold">{formatMoney(summary.d0_30)}</h3>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div
            className="card border-0 shadow-sm text-white"
            style={{ background: "linear-gradient(135deg, #08819c, #0a6b7a)" }}
          >
            <div className="card-body text-center py-4">
              <h6 className="mb-2 opacity-75">31-60 Days</h6>
              <h3 className="mb-0 fw-bold">{formatMoney(summary.d31_60)}</h3>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div
            className="card border-0 shadow-sm text-white"
            style={{ background: "linear-gradient(135deg, #F76B1D, #e05a0d)" }}
          >
            <div className="card-body text-center py-4">
              <h6 className="mb-2 opacity-75">61-90 Days</h6>
              <h3 className="mb-0 fw-bold">{formatMoney(summary.d61_90)}</h3>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div
            className="card border-0 shadow-sm text-white"
            style={{ background: "linear-gradient(135deg, #3e3e3e, #2b2a2a)" }}
          >
            <div className="card-body text-center py-4">
              <h6 className="mb-2 opacity-75">Total Outstanding</h6>
              <h3 className="mb-0 fw-bold">{formatMoney(summary.total)}</h3>
            </div>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <CustomTable
        title=""
        headData={headData}
        data={rows}
        total_count={total_count}
        records={perPage}
        activePage={activePage}
        handleChangeNextPage={setActivePage}
        colSpan={headData.length}
        customPage
      >
        {loading ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={headData.length} align="center">
                <LoadingGif />
              </TableCell>
            </TableRow>
          </TableBody>
        ) : rows.length > 0 ? (
          <TableBody>
            {rows.map((row, idx) => {
              const cnt = (activePage - 1) * perPage + idx + 1;
              return (
                <TableRow key={row.customer_id || cnt} hover>
                  <TableCell>{cnt}</TableCell>
                  <TableCell>{row.provider_name || "-"}</TableCell>
                  <TableCell>{row.provider_type || "-"}</TableCell>
                  <TableCell>
                    {row.currency_symbol
                      ? `${row.currency_symbol} (${row.currency_name})`
                      : row.currency_name || "-"}
                  </TableCell>
                  <TableCell className="text-end">{row["0_to_30"] || 0}</TableCell>
                  <TableCell className="text-end">{row["31_to_60"] || 0}</TableCell>
                  <TableCell className="text-end">{row["61_to_90"] || 0}</TableCell>
                  <TableCell className="text-end">{row.over_90 || 0}</TableCell>
                  <TableCell className="text-end fw-bold">{row.total || 0}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell colSpan={headData.length} align="center">
                No records found
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </CustomTable>
    </Container>
  );
};

const mapStateToProps = (state) => ({ snackbars: state.snackbar });
const mapDispatchToProps = (dispatch) => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) }
});

export default connect(mapStateToProps, mapDispatchToProps)(DebtorsAgeingReport);